import { CircularProgress, Grid, Typography } from '@mui/material';
import { confirmOneTimeAccess } from 'apis/controllers/membership';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import '../register/Register.css';
import RegisterForm from '../register/RegisterForm';
import OneTimeLinkError from '../register/OneTimeLinkError';

const TransferAccess = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('token');
    const [validToken, setValidToken] = useState(null);
    const [loading, setLoading] = useState(true);
    const [formData, setFormData] = useState(null);
    const { t } = useTranslation();

    const validateToken = async () => {
        try {
            const res = await confirmOneTimeAccess({ token }); // api call
            if (res?.status === 'success') {
                setValidToken(true);
                setFormData(res?.data);
            } else setValidToken(false);
        } catch (e) {
            setValidToken(false);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        validateToken();
    }, []);

    if (loading)
        return (
            <Grid container sx={{ width: '100%', minHeight: '80vh', justifyContent: 'center', alignContent: 'center' }}>
                <CircularProgress />
            </Grid>
        );
    if (!loading && !validToken)
        return (
            <Grid container sx={{ width: '100%', minHeight: '80vh', justifyContent: 'center', alignContent: 'center' }}>
                <OneTimeLinkError />
            </Grid>
        );
    return (
        <div className="register-container">
            <div className="card">
                <RegisterForm formData={formData} transfer={true} />
            </div>
        </div>
    );
};

export default TransferAccess;
